import Decimal from "decimal.js";
import { DateTime } from "luxon";

import { gf_yield } from "./eikisBondMathImplementation/gf_CML_funcs";
import { CORPORATE_BONDS, DEFAULT_REDEMPTION_PRICE } from "./eikisBondMathImplementation/bondMathConstants";
import { CouponPayment, CouponFrequency, BondPriceNominal, Yield, asYield } from "@goodfill/domain-properties";
import { assertIsDecimalFinite, assertIsDateTimeValid } from "../utils";

export function calculateYield(
  bondTimezone: string,
  couponPayment: CouponPayment,
  frequencyOfPaymentsPerYear: CouponFrequency,
  bondPrice: BondPriceNominal,
  bondMaturity: DateTime,
  settledAt: DateTime,
): Yield {
  assertIsDecimalFinite(couponPayment, "couponPayment");
  assertIsDecimalFinite(frequencyOfPaymentsPerYear, "frequencyOfPaymentsPerYear");
  assertIsDecimalFinite(bondPrice, "bondPrice");

  assertIsDateTimeValid(bondMaturity, "bondMaturity");
  assertIsDateTimeValid(settledAt, "settledAt");

  return asYield(
    new Decimal(
      gf_yield(
        bondTimezone,
        settledAt,
        bondMaturity,
        couponPayment.toNumber(),
        bondPrice.toNumber() * 100,
        DEFAULT_REDEMPTION_PRICE,
        CORPORATE_BONDS,
      ),
    ),
  );
}
